// @flow
import type {FileComponents} from 'docs/data/integration-builder';

export const getActiveFile = (
  files: FileComponents,
  step: string,
): string | null => {
  return (
    Object.keys(files).find((filename) =>
      files[filename].props?.children?.props?.children?.props?.steps?.includes(
        step,
      ),
    ) || null
  );
};
